import React from 'react';
import { ItemPreview } from './Preview';
import { style } from '@project/store/Legend';
import { ClusterStyleLegend } from './ClusterStyleLegend';
import { HeatMapStyleLegend } from './HeatMapStyleLegend';

/** Создает элемент-`легенду слоя`. */
const legendNode = (key: number, name: string, style: Record<string, any>) => {
  return (
    <div
      key={key}
      style={{
        marginBottom: '0.5rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
      }}
    >
      <ItemPreview {...style} />
      <div style={{ flexGrow: 1, marginLeft: 5 }}>
        <span>{name}</span>
      </div>
    </div>
  );
};

export interface StyleLayerLegendProps {
  style: style.LayerStyle;
}

export const StyleLayerLegend: React.FC<StyleLayerLegendProps> = ({
  style,
}) => {
  const heatmap = style.heatmap ? style.heatmap : undefined;
  const custermap = style.clustermap ? style.clustermap : undefined;
  const isDefaultStyle = !heatmap && !custermap && !!style.default;
  const isConditionalStyle = !heatmap && !custermap && !!style.conditional;

  return (
    <>
      {custermap && <ClusterStyleLegend style={custermap} />}
      {heatmap && <HeatMapStyleLegend style={heatmap} />}

      {isDefaultStyle && legendNode(-1, 'Основной стиль', style.default)}
      {isConditionalStyle &&
        style.conditional.map((condition, i) =>
          legendNode(i, condition.name || 'Без имени', condition.style),
        )}
    </>
  );
};
